import { InfoApiService } from "../api/InfoService";
import { IResult } from "../models/results/result.interface";
import { b64ToBlob } from "../utils/fileUtil";
import logger from "../utils/logger";
import { apiDateFormatting } from "../utils/dateUtil";
import { ReportTypes } from "../models/reports.interface";

const getReport = async (
  type: string,
  from?: string,
  to?: string,
  entityId?: string,
  studyId?: string,
  activeOnly?: boolean
): Promise<IResult<Blob>> => {
  logger.info(
    getReport.name,
    `Getting Report ${type} for ${entityId && `entity ${entityId}`} ${studyId &&
      `study ${studyId} ${activeOnly && "with active users only"}`}
    } from ${from} to ${to}`
  );

  try {
    if (from) {
      from = apiDateFormatting(from);
    }

    if (to) {
      to = apiDateFormatting(to);
    }

    const getRequest = () => {
      switch (type) {
        case ReportTypes.NonProUsers:
          return InfoApiService.infoGetNonProUsersReportByEntity({
            distId: +entityId!,
            onlyActiveUsers: activeOnly,
          });
        case ReportTypes.ProUsers:
          return InfoApiService.infoGetOrganizationProUsersReport({
            studyId: studyId ?? undefined,
          });
        case ReportTypes.EcgList:
          if (entityId) {
            return InfoApiService.infoGetEcgListReportByEntity({
              distId: +entityId,
              fromDate: from,
              toDate: to,
            });
          }
          if (studyId) {
            return InfoApiService.infoGetEcgListReportByStudy({
              studyId,
              fromDate: from,
              toDate: to,
            });
          }
          return InfoApiService.infoGetStandaloneOrganizationEcgListReport({
            fromDate: from,
            toDate: to,
          });

        default:
          throw new Error("Type is not specified");
      }
    };

    const { response: resp, error } = await getRequest();

    if (error || !resp || !resp.reportData) {
      logger.error(getReport.name, "Invalid API response", {
        resp,
        error,
      });
      return {
        success: false,
        message: error?.errorMessage,
        errorCode: error?.errorCode?.toString(),
      };
    }

    const file = b64ToBlob(resp.reportData, "text/csv");

    return {
      success: true,
      data: file,
    };
  } catch (error) {
    logger.error(getReport.name, "Error getting report.", error);
    return {
      success: false,
      message: (error as Error).message,
    };
  }
};

const reportsService = { getReport };

export default reportsService;
